import React from "react";
import { CalendarX } from "lucide-react";

export interface CalendarEvent {
  id: string;
  title: string;
  description: string;
}

interface Props {
  title: string;
  events: CalendarEvent[];
  canCreate: boolean;
  onCreate?: () => void;
  onEventClick: (e: CalendarEvent) => void;
  getEventColor: (id: string) => string;
}

export default function SelectedDaySidebar({ title, events, canCreate, onCreate, onEventClick, getEventColor }: Props) {
  return (
    <div className="hidden md:flex md:w-72 bg-white border-l border-gray-200 flex-col overflow-hidden shadow-lg m-2 ml-0">
      <div className="p-4 flex-1 overflow-y-auto flex flex-col bg-gradient-to-b from-white to-gray-50">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-sm font-semibold text-gray-800 border-l-4 border-blue-500 pl-2">{title}</h3>
        </div>

        <div className="flex-1 space-y-2 mb-3">
          {events.length > 0 ? (
            events.map((event) => (
              <div
                key={event.id}
                onClick={() => onEventClick(event)}
                className={`p-3 rounded-lg text-xs cursor-pointer transition-all hover:shadow-lg border ${getEventColor(event.id)}`}>
                <div className="font-semibold">{event.title}</div>
                {event.description && <div className="text-xs opacity-75 mt-1 line-clamp-2">{event.description}</div>}
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center text-center py-8 text-gray-400">
              <CalendarX className="w-12 h-12 mb-3 opacity-50" />
              <p className="text-sm">Bu günde etkinlik bulunmuyor.</p>
            </div>
          )}
        </div>

        {canCreate && (
          <button
            onClick={onCreate}
            className="w-full bg-green-600 text-white px-4 py-2.5 rounded-lg text-sm font-semibold hover:bg-green-700 shadow-md hover:shadow-lg transition-all">
            + Yeni Etkinlik
          </button>
        )}
      </div>
    </div>
  );
}
